import * as React from "react";
import { Icon, Popover } from "antd";
import "./style.scss";

interface ToplineSectionProps {
  aggregateValue: string;
  deltaValue: string;
  percentDeltaValue: string;
  popoverContents: any;
  title: string;
}

export class ToplineSection extends React.Component<ToplineSectionProps, {}> {
  render() {
    let {
      aggregateValue,
      deltaValue,
      percentDeltaValue,
      popoverContents,
      title
    } = this.props;
    return (
      <div className="topline-section">
        <div style={{ color: "#5D6368" }}>
          {title}
          <Popover
            placement="topLeft"
            arrowPointAtCenter
            title="Help"
            trigger="hover"
            content={popoverContents}
          >
            <Icon
              type="question-circle"
              style={{ marginLeft: 10, marginTop: 4 }}
            />
          </Popover>
        </div>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>
          {aggregateValue ? (
            <div style={{ float: "left" }}>{aggregateValue}</div>
          ) : (
            ""
          )}
          {aggregateValue ? (
            <div
              className="topline-metric-delta"
              style={{
                color:
                  (percentDeltaValue || "").indexOf("-") < 0
                    ? "#33A57B"
                    : "#F16565"
              }}
            >
              {deltaValue ? (
                <img
                  style={{ height: 15, marginTop: 2, float: "left" }}
                  src={
                    deltaValue.indexOf("-") < 0
                      ? "/trend-up.png"
                      : "/trend-down.png"
                  }
                />
              ) : (
                ""
              )}
              {deltaValue ? (
                <span>
                  <div style={{ display: "inline-block" }}>
                    &nbsp;&nbsp;{deltaValue}&nbsp;
                  </div>
                  <div style={{ display: "inline-block" }}>
                    {percentDeltaValue}
                  </div>
                </span>
              ) : (
                ""
              )}
            </div>
          ) : (
            <h1 style={{ fontSize: 20, color: "#D4D4D4", lineHeight: 0 }}>
              Unavailable
            </h1>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/ToplineMetrics/ToplineSection/index.tsx